module.exports = __webpack_public_path__ + "static/media/v_tn.ac7f9fca.png";